module.exports = __webpack_public_path__ + "static/media/logo_giztix.92e34837.svg";